$(document).ready(function ($d) {
  const windowLocation = theme.windowUrl;
  var server_closure = theme.server_url;
  // Add a response interceptor
  axios.interceptors.response.use(
    function (response) {
      $(".loader,.loader-2").hide();
      $("#diamond-count,#diamond-total-count").show();
      diamond_loading = true;
      isResetButtonClicked = false;
      return response;
    },

    function (error) {
      return Promise.reject(error);
    }
  );

  let diamond_count = 0;

  let total_diamond_count = 0;

  // compare diamond certificates

  let compare_diamond =
    JSON.parse(sessionStorage.getItem("compareCertificatesList")) || [];

  function diamond_listing_html(diamond) {
    const diamond_value = diamond.vaultDiscount === "True";
    let diamond_image = diamond?.image_url;
    let priceHtml = "";
    var currency_symbol = theme.country_currency_symbol;
    var currency_conversion_rate = 1;
    switch (theme.country_iso_code) {
      case "GB":
        currency_conversion_rate = 0.81;
        break;
      case "CA":
        currency_conversion_rate = 1.37;
        break;
      case "AU":
        currency_conversion_rate = 1.54;
        break;
      default:
    }
    let diamond_compare_price = parseInt(
      diamond?.total_sales_price * currency_conversion_rate
    );
    let diamond_price = parseInt(
      diamond?.total_discounted_sales_price * currency_conversion_rate
    );
    if (diamond.discount_perc) {
      let percentage_off = `${currency_symbol}${
        diamond_compare_price - diamond_price
      } OFF`;
      // if (diamond?.size > 1.99) {
      //   diamond_price = parseInt(
      //     diamond_price - 250 * currency_conversion_rate
      //   );
      //   percentage_off = `${currency_symbol}${
      //     250 * currency_conversion_rate
      //   } OFF + ${diamond?.discount_perc}% OFF`;
      // }
      priceHtml += `<div>
                  <span>${currency_symbol}${diamond_price.toLocaleString(
        "en-US"
      )}</span>
                  <span>${currency_symbol}${diamond_compare_price.toLocaleString(
        "en-US"
      )}</span>
        <span>(${percentage_off})</span>
      </div>`;
    } else {
      priceHtml += `<span class="main-price">${currency_symbol}${diamond_compare_price}</span>`;
    }

    return `<div class="diamond-list no-pair-diamond ${
      diamond_value ? "featured-diamond-wrapper" : ""
    }" data-diamond-json='${JSON.stringify(diamond)}'>

                <div class="diamond-compare ${
                  compare_diamond.indexOf(diamond?.cert_num) > -1
                    ? "active"
                    : ""
                }"><div><span></span></div></div>

                <div class="diamond-image-wrapper ${
                  diamond_value ? "featured-diamond" : ""
                }">

                <a href="${theme.diamond_product_url}?sku=${diamond?.cert_num}">

                  ${diamond_value ? "<p>Featured deal</p>" : ""}

                  <div class="diamond-image">

                    <img src="${diamond_image}"/>

                  </div>

                  </a>

                </div>

                

                <div class="medium-up--hide diamond-mobile-info">

                <a href="${theme.diamond_product_url}?sku=${diamond?.cert_num}">

                  <p>${diamond?.diamond_name}</p>

                  <p class="extra-info">${
                    diamond?.cut
                  } / ${diamond?.color} / ${diamond?.clarity} </p>

                  ${
                    diamond?.QuickShip == "Y"
                      ? "<p class='extra-quickship'>Quick Ship <span></span></p>"
                      : ""
                  }

                  <div class="extra-price-html diamond-price">${priceHtml}</div>

                  </a>

                </div>

                <div class="small--hide"><a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.shape}</a></div>

                <div class="small--hide"><a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.size}</a></div>

                <div class="small--hide"><a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.color}</a></div>

                <div class="small--hide"><a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.clarity}</a></div>

                <div class="small--hide"><a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.cut}</a></div>

                <div class="small--hide"><a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.lab}</a></div>

                <div class="additional-field small--hide">

                <a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.polish}</a></div>

                <div class="additional-field small--hide"><a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.symmetry}</a></div>

                <div class="additional-field small--hide"><a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.fluor_intensity}</a></div>

                <div class="additional-field small--hide"><a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.ratio}</a></div>

                <div class="additional-field small--hide"><a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.table_percent}</a></div>

                <div class="additional-field small--hide"><a href="${
                  theme.diamond_product_url
                }?sku=${diamond?.cert_num}">${diamond?.depth_percent}</a></div>

                <div class="diamond-price small--hide">

                <a href="${theme.diamond_product_url}?sku=${diamond?.cert_num}">

                  ${priceHtml}

                  </a>

                </div>
                <div class="arrow-wrapper">
                  <a href="/products/diamonds?sku=320481821"><p>SELECT</p></a>
                </div>
                </div>

              `;
  }

  function updateDiamondCount(diamond_count, totalDiamond) {
    total_diamond_count = parseInt(totalDiamond);

    console.log(diamond_count, total_diamond_count);

    $("#diamond-count,.diamond__all-diamond-tab span").text(
      total_diamond_count.toLocaleString("en-US")
    );
  }

  function loadDoc(filterArray, freshLoad) {
    if (freshLoad) {
      $(".diamond-body").html("");

      $(".diamonds-list .loader,.loader-2").show();

      $("#diamond-count,#diamond-total-count").hide();
    }

    var jsonData = { filter: filterArray };

    console.log(filterArray, filterArray[0]["shapes"]);

    const c1 = performance.now();

    axios

      .post(`${server_closure}/fetchdirectdiamond/`, jsonData)

      .then((res) => {
        if (freshLoad) {
          diamond_count = 0;

          page_count = 1;
        }

        const c2 = performance.now();

        console.log(res);

        console.log(`${c2 - c1} miliseconds`);

        $("#filter__shape").removeClass("disabled");

        const diamonds = res.data.data.liveDiamondData.diamond;
        var all_available_diamond_count =
          res.data.data.liveDiamondData.originalCount;
        $("#diamond-total-count span").text(all_available_diamond_count);
        console.log(diamonds);

        diamond_count += diamonds.length;

        updateDiamondCount(
          diamond_count,

          res.data.data.liveDiamondData.dataCount
        );

        let diamondsRenderList = "";

        diamonds.map((diamond) => {
          diamondsRenderList += diamond_listing_html(diamond);
        });

        if (freshLoad) {
          console.log(diamond_count);

          if (diamond_count) {
            $(".diamond-body").html(diamondsRenderList);
          } else {
            $(".diamond-body").html(
              `<p class="empty-diamond">No Diamonds Found.</p>`
            );
          }
        } else {
          $(".diamond-body").append(diamondsRenderList);
        }

        page_count += 1;
      })

      .catch((err) => {
        console.log(err);
      });
  }

  let shapes = [];

  // variable to check if reset button clicked

  let isResetButtonClicked = false;

  // Diamond filter array variables

  let diamond_loading = true;

  let allPageCount = 100;

  let cuts = [1, 2, 3];

  let colors = [5, 6, 7, 8];

  let claritys = [4, 5, 6, 7, 8];

  const polish = [0, 1, 2, 3];

  const symmetrys = [0, 1, 2, 3];

  let price = "100,700000";

  let carat = "1,20";

  let page_count = 1;

  let orderBy = "Price";

  let sortBy = "ASC";

  let lwratio = "0.9,2.75";

  const fluorescences = [0, 1, 2, 3];

  let sku = "";

  let table = "40,90";

  let depth = "40,90";

  let type = "";

  let diamond_type = "lab";

  let cert_num = "";

  let quick_ship_diamonds = "N";

  let Appointment = "";

  let VaultDiscount = "No";

  let reports = "";

  if (windowLocation.indexOf("natural-diamonds") > -1) {
    diamond_type = "natural";

    cuts = [0, 1, 2, 3];

    colors = [0, 1, 2, 3, 4, 5, 6, 7, 8];

    claritys = [0, 1, 2, 3, 4, 5, 6, 7, 8];

    carat = "0.25,20";
  }

  if (windowLocation.indexOf(theme.featured_diamond_handle) > -1) {
    VaultDiscount = "Yes";

    quick_ship_diamonds = "Y";

    $(".diamond__quick-shop-tab,.mm-filter-footer").hide();

    $(".diamond__quick-shop-tab").addClass("quick-active");
  }

  let filterArray;

  function default_diamond_filter() {
    filterArray = [
      { shapes },

      { cuts },

      { colors },

      { claritys },

      { labs: [] },

      { polish },

      { symmetrys },

      { price },

      { carat },

      { page: page_count },

      { orderBy },

      { sortBy },

      { lwratio },

      { fluorescences },

      { sku },

      { table },

      { depth },

      { type },

      { diamond_type },

      { cert_num },

      { quick_ship_diamonds },

      { Appointment },

      { VaultDiscount },

      { reports },
    ];
  }

  // Show only selected Ring shape option in diamond list

  let available_shapes = ["Round", "Oval"];

  const ring_settings = JSON.parse(
    localStorage.getItem("necklace-setting-information")
  );

  function selete_default_filter_shape(ring_setting_shape) {
    console.log("ring_setting_shape", ring_setting_shape, available_shapes);

    // if url has shape insert navigation shape

    if (
      windowLocation.indexOf("shape=") > -1 &&
      available_shapes.indexOf(windowLocation.split("shape=")[1]) > -1
    ) {
      shapes.push(windowLocation.split("?shape=")[1]);
    } else if (ring_setting_shape) {
      shapes.push(ring_setting_shape);
    }
  }

  if (ring_settings) {
    available_shapes = [];
    if (windowLocation.indexOf("natural-diamonds") > -1) {
      theme.remove_local_storage("necklace-natural-diamond-filter-setting");
    } else {
      theme.remove_local_storage("necklace-lab-diamond-filter-setting");
    }
    for (var key in ring_settings.variants) {
      $(".filter-shapes .shape[data-value='" + key + "']").show();
      available_shapes.push(key);
    }
    selete_default_filter_shape(ring_settings.shape);
  } else {
    $(".filter-shapes .shape").show();
    selete_default_filter_shape();
  }

  /******************** Apply diamond filter settings if user has stored the filter settings ********************/

  if (
    theme.get_local_storage("necklace-natural-diamond-filter-setting") &&
    windowLocation.indexOf("natural-diamonds") > -1
  ) {
    filterArray = JSON.parse(
      theme.get_local_storage("necklace-natural-diamond-filter-setting")
    );
  }

  if (
    theme.get_local_storage("necklace-lab-diamond-filter-setting") &&
    windowLocation.indexOf("lab-diamonds") > -1
  ) {
    filterArray = JSON.parse(
      theme.get_local_storage("necklace-lab-diamond-filter-setting")
    );
  }

  if (filterArray) {
    // Add tick to quickbox if quick_ship_diamonds is enabled in filter

    if (filterArray[20]["quick_ship_diamonds"] == "Y") {
      $(".diamond__quick-shop-tab").addClass("quick-active");
    }

    // Add tick to featured deals if localstorage has featured data

    if (filterArray[22]["VaultDiscount"] == "Yes") {
      $(".filter-featured-deals .text-box").addClass("active");
    }

    // Add tick to Report if localstorage has Report data

    if (filterArray[4]["labs"]) {
      const labs = filterArray[4]["labs"];

      labs.map(function (lab) {
        //console.log(report);

        $(".filter-report [data-value=" + lab + "]").addClass("active");
      });
    }
  } else {
    default_diamond_filter();
  }

  // override default/stored diamond carat filter on basis of carat in url

  if (windowLocation.indexOf("?carat=") > -1) {
    const caratNumberWithAmper = windowLocation.split("?carat=")[1];

    const caratNumber = caratNumberWithAmper.split("&")[0];

    if (caratNumber.indexOf("-") > -1) {
      const carat_split = caratNumber.split("-");

      filterArray[8]["carat"] = `${carat_split[0]},${carat_split[1]}`;
    } else {
      filterArray[8]["carat"] = `${caratNumber},20`;
    }

    console.log(filterArray, filterArray[8]["carat"]);
  }

  // override default/stored diamond price filter on basis of carat in url

  if (windowLocation.indexOf("?price=") > -1) {
    const priceNumberWithAmper = windowLocation.split("?price=")[1];

    const priceNumber = priceNumberWithAmper.split("&")[0];

    if (priceNumber.indexOf("-") > -1) {
      const price_split = priceNumber.split("-");

      filterArray[7]["price"] = `${price_split[0]},${price_split[1]}`;
    } else {
      filterArray[7]["price"] = `${priceNumber},700000`;
    }

    console.log(filterArray, filterArray[8]["carat"]);
  }

  // Add tick to shapes if localstorage has shapes

  if (filterArray[0]["shapes"].length) {
    filterArray[0]["shapes"].map(function (shape) {
      console.log(shape);

      $(".filter-shapes [data-value=" + shape + "]").addClass("active");
    });
  }

  /********************* store diamond filter settings for user *********************/

  function store_default_diamond_filter() {
    if (windowLocation.indexOf("natural-diamonds") > -1) {
      localStorage.setItem(
        "necklace-natural-diamond-filter-setting",

        JSON.stringify(filterArray)
      );
    }

    if (windowLocation.indexOf("lab-diamonds") > -1) {
      console.log(filterArray);

      localStorage.setItem(
        "necklace-lab-diamond-filter-setting",

        JSON.stringify(filterArray)
      );
    }
  }

  /*==== current filter settings ===*/

  function current_filter_setting(
    filter_array_place,

    filter_array_name,

    filter_array_type
  ) {
    if (filter_array_type == "text") {
      console.log(
        filterArray[filter_array_place][filter_array_name].split(",")
      );

      return filterArray[filter_array_place][filter_array_name].split(",");
    } else {
      const current_fitler = filterArray[filter_array_place][filter_array_name];

      return [current_fitler[0], current_fitler[current_fitler.length - 1] + 1];
    }
  }

  /*================== Diamond Filter slider settings ===================*/

  function update_min_max_attribute(
    start_input,

    start_val,

    end_input,

    end_val,

    min = 0,

    max = 0
  ) {
    start_input.attr("data-value", start_val);

    end_input.attr("data-value", end_val);

    if (min) {
      start_input.attr("data-min", min);
    }

    if (max) {
      end_input.attr("data-max", max);
    }
  }

  // Code to update diamond filter on slider value change

  function diamond_reload_on_filter_change() {
    page_count = 1;

    if (!isResetButtonClicked) {
      loadDoc(filterArray, true);

      isResetButtonClicked = true;
    }

    store_default_diamond_filter(filterArray);
  }

  function slide_stop_n_change_event(
    has_input,

    start_input,

    end_input,

    filter_array_place,

    filter_array_name,

    filter_array_type,

    handle,

    value1,

    value2
  ) {
    console.log(value1, value2, handle);

    if (filter_array_type == "array") {
      const number_array = [];

      for (var i = value1; i < value2; i++) {
        number_array.push(Math.round(i));
      }

      filterArray[filter_array_place][filter_array_name] = number_array;
    } else {
      filterArray[filter_array_place][filter_array_name] =
        value1 + "," + value2;
    }

    if (has_input) {
      update_min_max_attribute(start_input, value1, end_input, value2);
    }

    diamond_reload_on_filter_change();
  }

  // Initialize range slider on load

  function diamond_range_slider(
    selector,

    min,

    max,

    step,

    has_input,

    start_input,

    end_input,

    filter_array_place,

    filter_array_name,

    filter_array_type
  ) {
    const array_value = current_filter_setting(
      filter_array_place,

      filter_array_name,

      filter_array_type
    );

    if (filter_array_name === "price") {
      noUiSlider.create(selector, {
        start: [array_value[0], array_value[1]],

        connect: true,

        range: {
          min: [min, 1],

          "30%": [2000, 100],

          "70%": [10000, 500],

          "90%": [50000, 1000],

          max: [max],
        },
      });
    } else if (filter_array_name === "carat") {
      noUiSlider.create(selector, {
        start: [array_value[0], array_value[1]],

        connect: true,

        range: {
          min: [min, 0.01],

          "40%": [1, 0.05],

          "80%": [10, 0.5],

          max: [max],
        },
      });
    } else {
      noUiSlider.create(selector, {
        start: [array_value[0], array_value[1]],

        connect: true,

        margin: step,

        range: { min: min, max: max },

        step: step,
      });
    }

    // selector.slider({

    //   range: true,

    //   min: min,

    //   max: max,

    //   step: step,

    //   values: array_value,

    //   slide: function (event, ui) {

    //     if (has_input) {

    //       if (filter_array_name == "price") {

    //         start_input.val("$" + ui.values[0]);

    //         end_input.val("$" + ui.values[1]);

    //         // return false;

    //       } else if (filter_array_name == "carat") {

    //         start_input.val(ui.values[0] + " Ct.");

    //         end_input.val(ui.values[1] + " Ct.");

    //         // return false;

    //       } else {

    //         start_input.val(ui.values[0]);

    //         end_input.val(ui.values[1]);

    //       }

    //     }

    //   },

    //   change: function (event, ui) {

    //     slide_stop_n_change_event(

    //       has_input,

    //       start_input,

    //       end_input,

    //       filter_array_place,

    //       filter_array_name,

    //       filter_array_type,

    //       event,

    //       ui

    //     );

    //   },

    // });

    if (has_input) {
      selector.noUiSlider.on("update", function (values, handle) {
        if (filter_array_name === "price") {
          start_input.val("$" + Math.round(values[0]));

          end_input.val("$" + Math.round(values[1]));

          // return false;
        } else if (filter_array_name == "carat") {
          start_input.val(values[0] + " Ct.");

          end_input.val(values[1] + " Ct.");

          // return false;
        } else if (filter_array_name == "lwratio") {
          start_input.val(values[0]);

          end_input.val(values[1]);
        } else {
          start_input.val(Math.round(values[0]));

          end_input.val(Math.round(values[1]));
        }

        update_min_max_attribute(
          start_input,

          values[0],

          end_input,

          values[1],

          min,

          max
        );
      });
    }

    selector.noUiSlider.on("set", function (values, handle) {
      slide_stop_n_change_event(
        has_input,

        start_input,

        end_input,

        filter_array_place,

        filter_array_name,

        filter_array_type,

        handle,

        values[0],

        values[1]
      );
    });
  }

  // Diamond price slider

  const diamond_price_slider = $("#diamonds-price-slider")[0];

  const diamond_cut_slider = $("#diamonds-cut-slider")[0];

  const diamond_carat_slider = $("#diamonds-carat-slider")[0];

  const diamond_color_slider = $("#diamonds-color-slider")[0];

  const diamond_clarity_slider = $("#diamonds-clarity-slider")[0];

  const diamond_polish_slider = $("#diamonds-polish-slider")[0];

  const diamond_symmetry_slider = $("#diamonds-symmetry-slider")[0];

  const diamond_fluorescence_slider = $("#diamonds-fluorescence-slider")[0];

  const diamond_lw_ratio_slider = $("#diamonds-lw-ratio-slider")[0];

  const diamond_table_slider = $("#diamonds-table-slider")[0];

  const diamond_depth_slider = $("#diamonds-depth-slider")[0];

  if (diamond_price_slider) {
    diamond_range_slider(
      diamond_price_slider,

      100,

      700000,

      100,

      true,

      $("#slide-min-price"),

      $("#slide-max-price"),

      7,

      "price",

      "text"
    );
  }

  // Cut slider

  if (diamond_cut_slider) {
    diamond_range_slider(
      diamond_cut_slider,

      0,

      4,

      1,

      false,

      null,

      null,

      1,

      "cuts",

      "array"
    );
  }

  // Carat slider

  if (diamond_carat_slider) {
    diamond_range_slider(
      diamond_carat_slider,

      0.25,

      20.3,

      0.04,

      true,

      $("#slide-min-carat"),

      $("#slide-max-carat"),

      8,

      "carat",

      "text"
    );
  }

  // Color slider

  if (diamond_color_slider) {
    diamond_range_slider(
      diamond_color_slider,

      0,

      9,

      1,

      false,

      null,

      null,

      2,

      "colors",

      "array"
    );
  }

  // Clarity slider

  if (diamond_clarity_slider) {
    diamond_range_slider(
      diamond_clarity_slider,

      0,

      9,

      1,

      false,

      null,

      null,

      3,

      "claritys",

      "array"
    );
  }

  // Clarity slider

  if (diamond_polish_slider) {
    diamond_range_slider(
      diamond_polish_slider,

      0,

      4,

      1,

      false,

      null,

      null,

      5,

      "polish",

      "array"
    );
  }

  // Symmetry slider

  if (diamond_symmetry_slider) {
    diamond_range_slider(
      diamond_symmetry_slider,

      0,

      4,

      1,

      false,

      null,

      null,

      6,

      "symmetrys",

      "array"
    );
  }

  // Fluorescence slider

  if (diamond_fluorescence_slider) {
    diamond_range_slider(
      diamond_fluorescence_slider,

      0,

      4,

      1,

      false,

      null,

      null,

      13,

      "fluorescences",

      "array"
    );
  }

  // L/W ratio slider

  if (diamond_lw_ratio_slider) {
    diamond_range_slider(
      diamond_lw_ratio_slider,

      0.9,

      2.75,

      0.01,

      true,

      $("#slide-min-lw-ratio"),

      $("#slide-max-lw-ratio"),

      12,

      "lwratio",

      "text"
    );
  }

  // Table slider

  if (diamond_table_slider) {
    diamond_range_slider(
      diamond_table_slider,

      40,

      90,

      1,

      true,

      $("#slide-min-table"),

      $("#slide-max-table"),

      15,

      "table",

      "text"
    );
  }

  // Depth slider

  if (diamond_depth_slider) {
    diamond_range_slider(
      diamond_depth_slider,

      40,

      90,

      1,

      true,

      $("#slide-min-depth"),

      $("#slide-max-depth"),

      16,

      "depth",

      "text"
    );
  }

  loadDoc(filterArray);

  function reset_slider_div(store_diamond_setting, obj) {
    // remove active class from filter button

    $(
      ".diamond-filter__container .filter__item,.diamond__quick-shop-tab"
    ).removeClass("active");

    // reset diamond filter json

    filterArray = [
      { shapes: [] },

      { cuts: [0, 1, 2, 3] },

      { colors: [0, 1, 2, 3, 4, 5, 6, 7, 8] },

      { claritys: [0, 1, 2, 3, 4, 5, 6, 7, 8] },

      { labs: [] },

      { polish: [0, 1, 2, 3] },

      { symmetrys: [0, 1, 2, 3] },

      { price: "100,1000000" },

      { carat: "0.25,20" },

      { page: 1 },

      { orderBy: "Price" },

      { sortBy: "ASC" },

      { lwratio: "0.9,2.75" },

      { fluorescences: [0, 1, 2, 3] },

      { sku: "" },

      { table: "40,90" },

      { depth: "40,90" },

      { type: "" },

      { diamond_type: diamond_type },

      { cert_num: "" },

      { quick_ship_diamonds: "N" },

      { Appointment: "" },

      { VaultDiscount: "No" },

      { reports: "" },
    ];

    if (store_diamond_setting) {
      store_default_diamond_filter(filterArray);

      diamond_reload_on_filter_change();

      return false;
    }

    if (obj.cert_num && obj.cert_num.length > 0) {
      filterArray[19]["cert_num"] = obj.cert_num;

      diamond_reload_on_filter_change();

      return false;
    }

    if (obj.sku && obj.sku.length > 0) {
      filterArray[14]["sku"] = obj.sku;

      diamond_reload_on_filter_change();

      return false;
    }
  }

  // reset range slider on click on "Reset filter" button

  function reset_rang_slider() {
    diamond_price_slider.noUiSlider.set([100, null]); // code to set 1 value to 100

    diamond_price_slider.noUiSlider.set([null, 700000]); // code to set 2 value to 1000000

    $("#slide-min-price").val("$" + 100);

    $("#slide-max-price").val("$" + 1000000);

    diamond_cut_slider.noUiSlider.set([0, null]);

    diamond_cut_slider.noUiSlider.set([null, 4]);

    diamond_carat_slider.noUiSlider.set([0.25, null]);

    diamond_carat_slider.noUiSlider.set([null, 20.3]);

    $("#slide-min-carat").val(0.25 + " Ct.");

    $("#slide-max-carat").val(20.3 + " Ct.");

    diamond_color_slider.noUiSlider.set([0, null]);

    diamond_color_slider.noUiSlider.set([null, 9]);

    diamond_clarity_slider.noUiSlider.set([0, null]);

    diamond_clarity_slider.noUiSlider.set([null, 9]);

    diamond_polish_slider.noUiSlider.set([0, null]);

    diamond_polish_slider.noUiSlider.set([null, 4]);

    diamond_symmetry_slider.noUiSlider.set([0, null]);

    diamond_symmetry_slider.noUiSlider.set([null, 4]);

    diamond_fluorescence_slider.noUiSlider.set([0, null]);

    diamond_fluorescence_slider.noUiSlider.set([null, 4]);

    diamond_lw_ratio_slider.noUiSlider.set([0.9, null]);

    diamond_lw_ratio_slider.noUiSlider.set([null, 2.75]);

    diamond_table_slider.noUiSlider.set([40, null]);

    diamond_table_slider.noUiSlider.set([null, 90]);

    diamond_depth_slider.noUiSlider.set([40, null]);

    diamond_depth_slider.noUiSlider.set([null, 90]);
  }

  // Reset filters

  $(".reset-diamond-filter").on("click", function () {
    reset_slider_div(true);

    isResetButtonClicked = true;

    reset_rang_slider();
  });

  // Search diamond with certificate number

  function api_to_certificate_serach(cert_num) {
    const jsonData = {
      filter: [{ diamond_id: cert_num }],
    };

    console.log(jsonData);

    $(".diamond-body").html("");

    $(".diamonds-list .loader,.loader-2").show();

    $("#diamond-count,#diamond-total-count").hide();

    axios

      .post(
        `${server_closure}/fetchparticulardiamonddetail/`,

        jsonData
      )

      .then((res) => {
        const diamond_info = res.data.data.liveDiamondData.diamond[0];

        console.log(diamond_info);

        // return diamond_info;

        updateDiamondCount(1, 1);

        if (diamond_info) {
          const diamond_html = diamond_listing_html(diamond_info);

          $("#diamond-count,.diamond__all-diamond-tab span").text(1);

          $(".diamond-body").html(diamond_html);
        } else {
          $("#diamond-count,.diamond__all-diamond-tab span").text(0);

          $(".diamond-body").html(
            `<p class="empty-diamond">No Diamonds Found.</p>`
          );
        }
      })

      .catch((err) => {
        console.log(err);
      });
  }

  $(".diamond-certificate-serach button").on("click", function () {
    const cert_num = $(this)
      .closest(".diamond-certificate-serach")

      .find("input")

      .val();

    api_to_certificate_serach(cert_num);

    // reset_slider_div(false, { cert_num });
  });

  // Search diamond with sku number

  $(".diamond-sku-serach button").on("click", function () {
    const sku = $(this).closest(".diamond-sku-serach").find("input").val();

    reset_slider_div(false, { sku });
  });

  // Change range slider value on change of respective input value

  $(".slider-value-wrapper input").on("click", function () {
    $(this).val("");
  });

  // function called when valid input value passed to range slider input field

  function refresh_range_slider(
    range_slider_id,

    min,

    max,

    slider_start_value,

    slider_end_value
  ) {
    $d("#" + range_slider_id)[0].noUiSlider.set([min, null]);

    $d("#" + range_slider_id)[0].noUiSlider.set([null, max]);

    // function is used to update min and max

    update_min_max_attribute(slider_start_value, min, slider_end_value, max);
  }

  // function called when input value changed/Focused

  function change_slider_input_val(
    input_prefix,

    input_suffix,

    input_field,

    input_value
  ) {
    // console.log(input_prefix, input_suffix, input_field, input_value);

    if (input_prefix.length) {
      input_field.val(input_prefix + input_value);
    } else if (input_suffix.length) {
      input_field.val(input_value + input_suffix);
    } else {
      input_field.val(input_value);
    }
  }

  // Code to trigger range slider on range slider input value change

  $(".slider-value-wrapper input").on("focusout", function () {
    const closest_slider_parent = $(this).closest(".filter-with-input-value");

    const slider_start_value = closest_slider_parent.find(
      ".slider-start-value"
    );

    const slider_end_value = closest_slider_parent.find(".slider-end-value");

    const range_slider_title = closest_slider_parent

      .find("h3")

      .text()

      .split("By ")[1];

    const range_slider_id = closest_slider_parent

      .find(".range-slider")

      .attr("id");

    const range_slider_type = closest_slider_parent.attr("id");

    const value = parseFloat($(this).val()) || 0;

    const min_start_value = parseFloat(slider_start_value.attr("data-min"));

    const max_end_value = parseFloat(slider_end_value.attr("data-max"));

    const past_start_value = parseFloat(slider_start_value.attr("data-value"));

    const past_end_value = parseFloat(slider_end_value.attr("data-value"));

    // input prefix($) and input suffix(Ct.) for price and carat range slider respectively

    let input_suffix = "";

    let input_prefix = "";

    if (range_slider_type.indexOf("filter__price") > -1) {
      input_prefix = "$";
    }

    if (range_slider_type.indexOf("filter__carat") > -1) {
      input_suffix = " Ct.";
    }

    const is_start_value = $(this).hasClass("slider-start-value");

    let start_value = closest_slider_parent.find(".slider-start-value").val();

    let end_value = closest_slider_parent.find(".slider-end-value").val();

    console.log("beforeParse", start_value, end_value);

    if (input_prefix.length) {
      console.log("test", input_suffix);

      start_value = start_value.replace("$", "");

      end_value = end_value.replace("$", "");
    } else if (input_prefix.length) {
      start_value = start_value.replace(" Ct.", "");

      end_value = end_value.replace(" Ct.", "");
    }

    start_value = parseFloat(start_value);

    end_value = parseFloat(end_value);

    console.log("afterParse", start_value, end_value);

    // return false;

    if (is_start_value) {
      if (value > end_value) {
        alert(
          `${
            range_slider_title.substr(0, 1).toUpperCase() +
            range_slider_title.substr(1)
          } Min value should be less than ${range_slider_title} max value`
        );

        console.log(
          input_prefix,

          input_suffix,

          slider_start_value,

          past_start_value
        );

        change_slider_input_val(
          input_prefix,

          input_suffix,

          slider_start_value,

          past_start_value
        );

        // slider_start_value.val(past_start_value);
      } else if (value < min_start_value) {
        alert(
          `${
            range_slider_title.substr(0, 1).toUpperCase() +
            range_slider_title.substr(1)
          } Min value should be greater than or equal to ${min_start_value}`
        );

        change_slider_input_val(
          input_prefix,

          input_suffix,

          slider_start_value,

          past_start_value
        );

        // slider_start_value.val(past_start_value);
      } else {
        change_slider_input_val(
          input_prefix,

          input_suffix,

          slider_start_value,

          value
        );

        console.log(value, end_value);

        refresh_range_slider(
          range_slider_id,

          value,

          end_value,

          slider_start_value,

          slider_end_value
        );
      }
    } else {
      if (value < start_value) {
        alert(
          `${
            range_slider_title.substr(0, 1).toUpperCase() +
            range_slider_title.substr(1)
          } Max value should be greater than ${range_slider_title} Min value`
        );

        change_slider_input_val(
          input_prefix,

          input_suffix,

          slider_end_value,

          past_end_value
        );

        // slider_end_value.val(past_end_value);
      } else if (value > max_end_value) {
        alert(
          `${
            range_slider_title.substr(0, 1).toUpperCase() +
            range_slider_title.substr(1)
          } Max value should be less than or equal to ${max_end_value}`
        );

        change_slider_input_val(
          input_prefix,

          input_suffix,

          slider_end_value,

          past_end_value
        );

        // slider_end_value.val(past_end_value);
      } else {
        change_slider_input_val(
          input_prefix,

          input_suffix,

          slider_end_value,

          value
        );

        refresh_range_slider(
          range_slider_id,

          start_value,

          value,

          slider_start_value,

          slider_end_value
        );
      }
    }
  });

  // code to filter by shape

  $(".filter-shapes .shape").on("click", function () {
    filterArray[0].shapes = [];

    $("#filter__shape").addClass("disabled");

    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    } else {
      $(this).addClass("active");
    }

    $(".filter-shapes .shape.active").each(function () {
      filterArray[0].shapes.push($(this).data("value"));
    });

    // check if ring settings is selected

    if (ring_settings && filterArray[0].shapes.length < 1) {
      filterArray[0].shapes.push(ring_settings.shape);

      $(
        '.filter-shapes .shape[data-value="' + ring_settings.shape + '"]'
      ).addClass("active");
    }

    store_default_diamond_filter();

    diamond_reload_on_filter_change();
  });

  // code to filter by featured deals

  $(".filter-featured-deals .text-box").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");

      $(".diamond__quick-shop-tab").removeClass("quick-active");

      filterArray[20]["quick_ship_diamonds"] = "N";

      filterArray[22]["VaultDiscount"] = "No";
    } else {
      $(this).addClass("active");

      $(".diamond__quick-shop-tab").addClass("quick-active");

      filterArray[20]["quick_ship_diamonds"] = "Y";

      filterArray[22]["VaultDiscount"] = "Yes";
    }

    store_default_diamond_filter();

    diamond_reload_on_filter_change();
  });

  // code to filter by Report

  $(".filter-report .text-box").on("click", function () {
    filterArray[4].labs = [];

    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    } else {
      $(this).addClass("active");
    }

    var report = "";

    $(".filter-report .text-box.active").each(function () {
      filterArray[4].labs.push($(this).data("value"));
    });

    diamond_reload_on_filter_change();
  });

  // code to filter by quickship diamond

  $(".diamond__quick-shop-tab").on("click", function () {
    const hasActiveClass = $(this).hasClass("quick-active");

    if (hasActiveClass) {
      $(this).removeClass("quick-active");

      filterArray[20]["quick_ship_diamonds"] = "N";
    } else {
      $(this).addClass("quick-active");

      filterArray[20]["quick_ship_diamonds"] = "Y";
    }

    $(".diamond__tab-wrapper .tab-box").removeClass("active");

    $(".diamond__tab-wrapper .diamond__all-diamond-tab").addClass("active");

    $(".diamond-body").show();

    $(".diamond-compare-body").hide();

    store_default_diamond_filter();

    diamond_reload_on_filter_change();
  });

  // Update localstorage compare diamond count

  function compare_diamond_count(stored_certificates_array) {
    $(".diamond__compare-diamond-tab span").text(
      stored_certificates_array.length
    );
  }

  compare_diamond_count(compare_diamond);

  // Load compare diamond listing

  function load_compare_diamond() {
    let render_html_data = "";

    let stored_certificates_obj =
      JSON.parse(sessionStorage.getItem("compare_certificate_obj")) || {};

    $.each(stored_certificates_obj, function (key, value) {
      console.log(value);

      render_html_data += diamond_listing_html(value);
    });

    console.log(render_html_data.length);

    if (render_html_data.length > 100) {
      $(".diamond-compare-body").html(render_html_data);

      console.log(1);
    } else {
      $(".diamond-compare-body").html(
        `<p class="empty-diamond">Please select diamond to compare.</p>`
      );

      console.log(2);
    }
  }

  // Add certificate number to array and object compare

  $(document).on("click", ".diamond-list .diamond-compare", function () {
    const hasActiveClass = $(this).hasClass("active");

    const diamond_data = $(this).closest(".diamond-list").data("diamond-json");

    // let stored_certificates_array =

    //   JSON.parse(sessionStorage.getItem("compareCertificatesList")) || [];

    let stored_certificates_obj =
      JSON.parse(sessionStorage.getItem("compare_certificate_obj")) || {};

    if (hasActiveClass) {
      const indexNumber = compare_diamond.indexOf(diamond_data["cert_num"]);

      compare_diamond.splice(indexNumber, 1);

      delete stored_certificates_obj[diamond_data["cert_num"]];

      $(this).removeClass("active");
    } else {
      $(this).addClass("active");

      compare_diamond.push(diamond_data["cert_num"]);

      stored_certificates_obj[diamond_data["cert_num"]] = diamond_data;
    }

    sessionStorage.setItem(
      "compareCertificatesList",

      JSON.stringify(compare_diamond)
    );

    sessionStorage.setItem(
      "compare_certificate_obj",

      JSON.stringify(stored_certificates_obj)
    );

    compare_diamond_count(compare_diamond);

    load_compare_diamond();
  });

  // save diamond in cookies and redirect to diamond product page

  $(document).on("click", ".diamonds-list-container a", function (e) {
    // e.preventDefault();

    let diamond_pdp_obj = theme.get_local_storage("diamond-pdp-obj");

    if (diamond_pdp_obj) {
      diamond_pdp_obj = JSON.parse(diamond_pdp_obj);
    } else {
      diamond_pdp_obj = {};
    }

    console.log(diamond_pdp_obj);

    const diamond_json_data = $(this)
      .closest(".diamond-list")

      .data("diamond-json");

    console.log(diamond_json_data, typeof diamond_json_data);

    // push diamond information in session object

    diamond_pdp_obj[diamond_json_data.cert_num] = diamond_json_data;

    theme.set_local_storage("diamond-pdp-obj", JSON.stringify(diamond_pdp_obj));

    // window.location.href =

    //   theme.diamond_product_url + "/" + diamond_json_data?.cert_num;
  });

  // Tab switch code

  $(".diamond__all-diamond-tab,.diamond__compare-diamond-tab").on(
    "click",

    function () {
      $(this)
        .closest(".diamond__tab-wrapper")

        .find(".tab-box")

        .removeClass("active");

      $(this).addClass("active");

      const tab_type = $(this).data("tab-type");

      if (tab_type == "diamond-compare-body") {
        load_compare_diamond();
      }

      $(".tab-content-container").hide();

      $("." + tab_type).show();
    }
  );

  // functionlity to sort the diamond on click on diamond header or sort by change

  function apply_sorting_on_diamond(_this, sort_name, sort_type) {
    console.log(sort_name, sort_type);

    const addClass = sort_type == "ASC" ? "sort-order-asc" : "sort-order-desc";

    const removeClass =
      sort_type == "ASC" ? "sort-order-desc" : "sort-order-asc";

    filterArray[10]["orderBy"] = sort_name;

    filterArray[11]["sortBy"] = sort_type;

    _this.removeClass(removeClass);

    _this.addClass(`active ${addClass}`);

    diamond_reload_on_filter_change();
  }

  $(".diamond-heading .sort-wrapper").on("click", function (e) {
    var sort_name = $(this).data("type");

    $(
      ".diamond-heading .sort-wrapper:not([data-type=" + sort_name + "])"
    ).removeClass("active sort-order-asc sort-order-desc");

    var sort_type = $(this).hasClass("sort-order-asc") ? "DESC" : "ASC";

    apply_sorting_on_diamond($(this), sort_name, sort_type);
  });

  // Custom select dropdown js

  $(".select-dropdown__button").on("click", function () {
    $(".select-dropdown__list").toggleClass("active");
  });

  $(".select-dropdown__list-item").on("click", function () {
    var itemValue = $(this).data("value");

    $(".select-dropdown__list-item").removeClass("active-dropdown");

    $(this).addClass("active-dropdown");

    $(".select-dropdown__button .sort_by-title").text(": " + $(this).text());

    $(".select-dropdown__list").toggleClass("active");

    var sort_name = itemValue.split("-")[0];

    var sort_type = itemValue.split("-")[1];

    $(
      ".diamond-heading .sort-wrapper:not([data-type=" + sort_name + "])"
    ).removeClass("active sort-order-asc sort-order-desc");

    var _this = $(".sort-wrapper[data-type=" + sort_name + "]");

    apply_sorting_on_diamond(_this, sort_name, sort_type);
  });

  // $("#diamond__sort-by").on("change", function (e) {

  //   const value = $(this).val();

  //   var sort_name = value.split("-")[0];

  //   var sort_type = value.split("-")[1];

  //   $(

  //     ".diamond-heading .sort-wrapper:not([data-type=" + sort_name + "])"

  //   ).removeClass("active sort-order-asc sort-order-desc");

  //   var _this = $(".sort-wrapper[data-type=" + sort_name + "]");

  //   apply_sorting_on_diamond(_this, sort_name, sort_type);

  // });

  // Load data on scroll

  // for mobile

  $(document).on("touchmove", onScroll);

  // for desktop

  $(window).scroll(function () {
    onScroll();
  });

  function onScroll() {
    var position = $(window).scrollTop();

    var bottom = $(document).height() - $(window).height() - 800;

    if (position >= bottom) {
      fetchData();
    }
  }

  function checkWindowSize() {
    if ($(window).height() >= $(document).height()) {
      fetchData();
    }
  }

  checkWindowSize();

  // Fetch records

  const is_diamond_body_visible = $(".diamond-body");

  function fetchData() {
    if (
      diamond_loading &&
      diamond_count < total_diamond_count &&
      is_diamond_body_visible.is(":visible")
    ) {
      diamond_loading = false;

      filterArray[9].page = page_count;

      loadDoc(filterArray);
    }
  }

  // diamond tab page change

  $(".diamond-tab").on("click", function (e) {
    e.preventDefault();

    if ($(this).hasClass("active")) {
      return false;
    }

    const diamond_tab_type = $(this).data("diamond");

    if (diamond_tab_type == "lab-diamonds") {
      window.location.href = `/collections/${theme.lab_diamond_handle}`;
    } else {
      window.location.href = `/collections/${theme.natural_diamond_handle}`;
    }
  });

  // show/hide addional diamond filters

  if ($(window).width() > 749) {
    var show_hide_click_count = 0;

    $(".show-hide-advance-filter").on("click", function (e) {
      if (show_hide_click_count % 2 == 0) {
        $(this).text("Hide Advance");
      } else {
        $(this).text("Show Advance");
      }

      e.preventDefault();

      $(".advance-filter-container").slideToggle();

      $(".diamond-heading,.diamond-body,.diamond-compare-body").toggleClass(
        "active"
      );
    });
  }
});
